import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

    @Input() text: string = "";
    @Input() disabled: boolean = false;
    @Input() verifyAllowFocus: boolean = false;
    @Input() className: string = "";

    @Output() click = new EventEmitter();
    @ViewChild('ref') ref: ElementRef;

    constructor(private globalService: GlobalService)
    {
        this.globalService.allowFocus.subscribe(
            () => {
                if (this.verifyAllowFocus) {
                    this.setTabindex();
                    this.setAriaHidden();
                }
            }
        );
    }

    ngOnInit() {
        setTimeout(() => {
            this.setTabindex(0);
            this.setAriaHidden("false");
        })
    }

    isDisabled() {
        return this.disabled ? 'disabled' : null;
    }

    setTabindex(tabindex: Number = null) {
        if (tabindex == null)
            tabindex = this.globalService.getKeyboardPermission();
        
        this.ref.nativeElement.setAttribute("tabindex", tabindex);
    }

    setAriaHidden(ariaHidden: string = null) {
        if (ariaHidden == null)
            ariaHidden = this.globalService.getSrPermission();

        this.ref.nativeElement.setAttribute("aria-hidden", ariaHidden);
    }
}
